import React, { useState, useEffect, useRef } from "react";
import { AnimatePresence, motion } from "framer-motion";
import { Carousel } from "antd";
import hairred1 from "../assets/HairReduction/img1.png";
import hairred2 from "../assets/HairReduction/img2.png";
import hairred3 from "../assets/HairReduction/img3.png";
import bodyscup1 from "../assets/bodysculpting/img1.png";
import bodyscup2 from "../assets/bodysculpting/img2.png";
import bodyscup3 from "../assets/bodysculpting/img3.png";
import analysers1 from "../assets/analysers/img1.png";
import analysers2 from "../assets/analysers/img2.png";
import hydra1 from "../assets/hydrafacial/img1.png";
import hydra2 from "../assets/hydrafacial/img2.png";
import skinlift1 from "../assets/skinlifting/img1.png";
import skinlift2 from "../assets/skinlifting/img2.png";
import skintight1 from "../assets/skin-tight/img1.png";
import skintight2 from "../assets/skin-tight/img2.png";
import skintight3 from "../assets/skin-tight/img3.png";
import pigment1 from "../assets/pigmentremoval/img1.png";
import hairgrowth from '../assets/hair-regrowth/HAIR-BOOSTER.png'
import bg from '../assets/BG.jpg'


const equipmentCategories = [
  { id: "hair-reduction", name: "Hair Reduction" },
  { id: "pigment-removal", name: "Pigment Removal" },
  { id: "skin-tightening", name: "Skin Tightening" },
  { id: "analysers", name: "Analysers" },
  { id: "skin-lifting", name: "Skin Lifting" },
  { id: "hydrafacial", name: "HydraFacial" },
  { id: "body-sculpting", name: "Body Sculpting" },
  { id: "hair-regrowth", name: "Hair Regrowth" },
];

const equipmentData = {
  "hair-reduction": [
    {
      id: "laser-hair-removal",
      name: "Diode Laser Hair Removal",
      features: ["Painless", "Long-lasting", "Safe for all skin types"],
      images: [hairred1, hairred1, hairred1],
    },
    {
      id: "ipl-hair-removal",
      name: "IPL Hair Removal Machine",
      features: [
        "Fast treatment",
        "Minimal side effects",
        "Suitable for body and face",
      ],
      images: [hairred2, hairred2, hairred2],
    },
    {
      id: "ipl-hair-removal2",
      name: "DIODE ITALO ITALY LUSTRO",
      features: [
        "Fast treatment",
        "Minimal side effects",
        "Suitable for body and face",
      ],
      images: [hairred3, hairred3, hairred3],
    },
  ],
  "pigment-removal": [
    {
      id: "pico-laser",
      name: "Pico Laser Machine",
      features: ["Quick results", "Low discomfort", "Improves skin texture"],
      images: [pigment1, pigment1, pigment1],
    },
  ],
  "skin-tightening": [
    {
      id: "skin-tightening-machine",
      name: "Skin Tightening Machine",
      features: ["Painless", "Long-lasting", "Safe for all skin types"],
      images: [skintight1, skintight1, skintight1],
    },
    {
      id: "ipl-skin-tightening",
      name: "IPL Skin Tightening",
      features: [
        "Fast treatment",
        "Minimal side effects",
        "Suitable for body and face",
      ],
      images: [skintight2, skintight2, skintight2],
    },
    {
      id: "ipl-skin-tightening2",
      name: "IPL Skin Tightening",
      features: [
        "Fast treatment",
        "Minimal side effects",
        "Suitable for body and face",
      ],
      images: [skintight3, skintight3, skintight3],
    },
  ],

  "body-sculpting": [
    {
      id: "body-sculpting",
      name: "2 in 1 SCULPTURE AND CRYOLIPOLYSIS MACHINE",
      features: ["Quick results", "Low discomfort", "Improves skin texture"],
      images: [bodyscup1, bodyscup1, bodyscup1],
    },
    {
      id: "body-sculpting2",
      name: "Rotary Negative Pressure RF + Inner ball Rollrt Machine",
      features: ["Quick results", "Low discomfort", "Improves skin texture"],
      images: [bodyscup2, bodyscup2, bodyscup2],
    },
    {
      id: "body-sculpting3",
      name: "CAVIZERO",
      features: ["Quick results", "Low discomfort", "Improves skin texture"],
      images: [bodyscup3, bodyscup3, bodyscup3],
    },
  ],
  analysers: [
    {
      id: "analysers",
      name: "Pico Laser Machine",
      features: ["Quick results", "Low discomfort", "Improves skin texture"],
      images: [analysers1, analysers1, analysers1],
    },
    {
      id: "analysers2",
      name: "Pico Laser Machine 2",
      features: ["Quick results", "Low discomfort", "Improves skin texture"],
      images: [analysers2, analysers2, analysers2],
    },
  ],
  hydrafacial: [
    {
      id: "hydrafacial",
      name: "Pico Laser Machine",
      features: ["Quick results", "Low discomfort", "Improves skin texture"],
      images: [hydra1, hydra1, hydra1],
    },
    {
      id: "hydrafacial2",
      name: "Pico Laser Machine 2",
      features: ["Quick results", "Low discomfort", "Improves skin texture"],
      images: [hydra2, hydra2, hydra2],
    },
  ],
  "skin-lifting": [
    {
      id: "skin-lifting",
      name: "Pico Laser Machine",
      features: ["Quick results", "Low discomfort", "Improves skin texture"],
      images: [skinlift1, skinlift1, skinlift1],
    },
    {
      id: "skin-lifting2",
      name: "Pico Laser Machine 2",
      features: ["Quick results", "Low discomfort", "Improves skin texture"],
      images: [skinlift2, skinlift2, skinlift2],
    },
    
  ],
  "hair-regrowth": [
    {
      id: "hair-regrowth",
      name: "Pico Laser Machine",
      features: ["Quick results", "Low discomfort", "Improves skin texture"],
      images: [hairgrowth, hairgrowth, hairgrowth],
    },
    
    
  ],
  // Add other categories similarly...
};

export default function Feature() {
  const [activeCategoryId, setActiveCategoryId] = useState("hair-reduction");
  const [activeMachineId, setActiveMachineId] = useState(
    equipmentData["hair-reduction"][0].id
  );
  const [activeImageIndex, setActiveImageIndex] = useState(0);
  const scrollRef = useRef(null);

  // Get the machines for the currently active category
  const machines = equipmentData[activeCategoryId] || [];
  const machine = machines.find((m) => m.id === activeMachineId) || {};

  const [activeMachineIndex, setActiveMachineIndex] = useState(0);
  const activeMachine = machines[activeMachineIndex];

  //
  const handleNext = () => {
    setActiveMachineIndex((prevIndex) => (prevIndex + 1) % machines.length);
  };

  const handlePrev = () => {
    setActiveMachineIndex(
      (prevIndex) => (prevIndex - 1 + machines.length) % machines.length
    );
  };

  useEffect(() => {
    setActiveMachineId(machines[activeMachineIndex].id);
  }, [activeMachineIndex, machines, activeCategoryId]);

  //

  useEffect(() => {
    const interval = setInterval(() => {
      if (machine.images && machine.images.length > 0) {
        setActiveImageIndex(
          (prevIndex) => (prevIndex + 1) % machine.images.length
        );
      }
    }, 3000);

    return () => clearInterval(interval);
  }, [machine.images]);

  const slideVariants = {
    enter: { opacity: 0, scale: 0.8 },
    center: { opacity: 1, scale: 1, transition: { duration: 0.5 } },
    exit: { opacity: 0, scale: 0.8, transition: { duration: 0.5 } },
  };

  const handleCategoryClick = (categoryId) => {
    setActiveCategoryId(categoryId);
    setActiveMachineId(equipmentData[categoryId][0].id); // Set to first machine of new category
    setActiveImageIndex(0);
    if (scrollRef.current) {
      scrollRef.current.scrollIntoView({ behavior: "smooth", block: "start" });
    }
  };

  const handleMachineChange = (index) => {
    const selectedMachine = machines[index];
    if (selectedMachine) {
      // setActiveMachineId(selectedMachine.id);
      setActiveImageIndex(0);
    }
  };

  const customstyles = {
    backgroundImage: `url(${bg})`,
    backgroundSize: "cover",
    backgroundPosition: "center",
  };

  return (
    <div className=" pt-5 pb-5" style={customstyles} >
      <div className="container mx-auto px-4 my-20 ">
        <h2 className="font-bold text-center mb-6 text-3xl text-colorPrimary">
          FEATURED EQUIPMENT
        </h2>

        <div className="grid grid-cols-2 md:grid-cols-8 gap-5 mb-8">
          {equipmentCategories.map((category) => (
            <>
            <button
              key={category.id}
              className={`px-4 py-4  rounded-lg text-sm font-medium transition-colors ${
                activeCategoryId === category.id
                  ? "bg-colorPrimary text-white"
                  : "bg-white border border-colorPrimary text-gray-800 hover:bg-gray-300"
              }`}
              onClick={() => handleCategoryClick(category.id)}
            >
           {category.name}
            </button>

            </>
          ))}
        </div>

        <div className="relative" >
          {/* Navigation Buttons */}

          <div key={activeMachine.id} className="w-full">
            <div className="grid lg:grid-cols-2 grid-cols-1">
              {/* Machine Information */}
              <div className="flex flex-col gap-6 items-center p-6  rounded-lg ">
                <h3 className="text-3xl font-extrabold text-colorPrimary mb-4">
                  {activeMachine.name}
                </h3>
                <ul className="grid grid-cols-1 sm:grid-cols-2 gap-6 mb-6">
                  {activeMachine.features &&
                    activeMachine.features.map((feature, featureIndex) => (
                      <li
                        key={featureIndex}
                        className="flex items-center p-3 bg-white rounded-lg shadow-md hover:shadow-xl transition-shadow duration-300"
                      >
                        <svg
                          className="w-5 h-5 mr-3 text-green-500"
                          fill="none"
                          strokeLinecap="round"
                          strokeLinejoin="round"
                          strokeWidth="2"
                          viewBox="0 0 24 24"
                          stroke="currentColor"
                        >
                          <path d="M5 13l4 4L19 7"></path>
                        </svg>
                        <span className="text-gray-800 font-medium">
                          {feature}
                        </span>
                      </li>
                    ))}
                </ul>
                <div className="flex justify-center mt-6">
                  <div className="bg-white rounded-lg overflow-hidden shadow-md">
                    <a
                      download
                      className="flex items-center justify-center px-6 py-3 text-sm font-semibold text-white bg-gray-800 hover:bg-gray-700 transition-colors duration-300"
                    >
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width="20px"
                        fill="currentColor"
                        className="mr-2"
                        viewBox="0 0 24 24"
                      >
                        <path d="M12 16a.749.749 0 0 1-.542-.232l-5.25-5.5A.75.75 0 0 1 6.75 9H9.5V3.25c0-.689.561-1.25 1.25-1.25h2.5c.689 0 1.25.561 1.25 1.25V9h2.75a.75.75 0 0 1 .542 1.268l-5.25 5.5A.749.749 0 0 1 12 16zm10.25 6H1.75C.785 22 0 21.215 0 20.25v-.5C0 18.785.785 18 1.75 18h20.5c.965 0 1.75.785 1.75 1.75v.5c0 .965-.785 1.75-1.75 1.75z" />
                      </svg>
                      Download PDF
                    </a>
                  </div>
                </div>
              </div>

              {/* Images */}
              <div className="flex justify-evenly items-center">
                <button
                  onClick={handlePrev}
                  className="lg:absolute left-0 top-1/2 transform -translate-y-1/2 p-2 bg-gray-700 text-white rounded-xl"
                >
                  &lt;
                </button>

                <div className="relative flex flex-col items-center justify-center mb-4">
                  <AnimatePresence mode="wait">
                    <motion.div
                      key={activeImageIndex}
                      className="w-64 h-auto"
                      variants={slideVariants}
                      initial="enter"
                      animate="center"
                      exit="exit"
                    >
                      <img
                        src={machine.images[activeImageIndex]}
                        alt={machine.name}
                        className="w-full h-auto"
                      />
                    </motion.div>
                  </AnimatePresence>
                </div>

                <div className="flex flex-col gap-2">
                  {activeMachine.images &&
                    activeMachine.images.map((img, imgIndex) => (
                      <img
                        key={imgIndex}
                        src={img}
                        alt={`${activeMachine.name} view ${imgIndex + 1}`}
                        onClick={() => setActiveImageIndex(imgIndex)} // Ensure this function is defined
                        className={`w-16 h-auto rounded cursor-pointer transition-opacity ${
                          imgIndex === activeImageIndex
                            ? "opacity-100 ring-2 ring-blue-500"
                            : "opacity-70 hover:opacity-100"
                        }`}
                      />
                    ))}
                </div>
                <button
                  onClick={handleNext}
                  className=" lg:absolute rounded-xl right-0 top-1/2 transform -translate-y-1/2 p-2 bg-gray-700 text-white "
                >
                  &gt;
                </button>
              </div>
            </div>
          </div>

          {/* Right Navigation Button */}
        </div>
      </div>
    </div>
  );
}
